import { defineStore } from 'pinia';
import { api } from '@services/AxiosBootstrap';
import { useAppStore } from '@stores/App';

/**
 Route::middleware(['auth:sanctum', 'verified'])->group(function () {
 Route::get('wishlist', [WishlistListController::class, 'execute']);
 // Wishlist can be public, but still needs to be inside sanctum to get the user for the private ones
 Route::get('wishlist/{id}', [WishlistViewController::class, 'execute']);
 Route::post('wishlist', [WishlistCreateController::class, 'execute']);
 Route::patch('wishlist/{id}', [WishlistEditController::class, 'execute']);
 Route::delete('wishlist/{id}', [WishlistDeleteController::class, 'execute']);
 Route::post('wishlist/{id}/item', [WishlistItemAddController::class, 'execute']);
 Route::patch('wishlist/{id}/item/{productId}', [WishlistItemEditController::class, 'execute']);
 Route::delete('wishlist/{id}/item/{productId}', [WishlistItemDeleteController::class, 'execute']);
 });
 // Wishlist can be public, but still needs to be inside sanctum to get the user for the private ones
 Route::get('wishlist/public/{uuid}', [WishlistViewController::class, 'execute']);
 */

const defaultState = () => {
    return {
        lists: []
    };
};

export const useWishlistStore = defineStore('wishlists', {
    state: () => {
        return null;
    },
    getters: {
        token: (state) => {
            return state.token;
        },
    },
    actions: {
        getWishlistTypeThemes() {
            return [
                {
                    id: 'standard',
                    label: 'wishlist.typeTheme.standard',
                },
                {
                    id: 'christmas',
                    label: 'wishlist.typeTheme.christmas',
                }
            ];
        },
        async getWeddingList() {
            const response = await api.get(`/wishlist/wedding-list`);
            return response.data.data;
        },
        async getPublicList(wishlistId) {
            const response = await api.get(`/wishlist/public/${wishlistId}`);
            return response.data.data;
        },
        async getProductIds() {
            const response = await api.get(`/wishlist/product-ids`);
            return response.data.data;
        },
        async getLists() {
            const response = await api.get('/wishlist');
            console.log('wishlist', response);
            return response.data.data;
        },
        async createList(name, isPublic) {
            const response = await api.post('/wishlist', {
                name,
                public: !!isPublic,
            });
            return response.data.data;
        },
        async createWeddingList(name, form)
        {
            const { meta, date, location } = form;
            const response = await api.post('/wishlist', {
                name,
                type: 'wedding',
                public: true,
                date,
                location,
                meta,
            });
            return response.data.data;
        },
        async getListItems(wishlistId) {
            const response = await api.get(`/wishlist/${wishlistId}`);
            return response.data.data;
        },
        async updateList(wishlistId, data) {
            const response = await api.patch(`/wishlist/${wishlistId}`, data);
            return response.data.data;
        },
        async deleteList(wishlistId) {
            const response = await api.delete(`/wishlist/${wishlistId}`);
            return response.data.data;
        },
        async addProduct(wishlistId, productUuid, quantity) {
            const response = await api.post(`/wishlist/${wishlistId}/item`, {
                product_id: productUuid,
                qty: quantity,
            });
            return response.data;
        },
        async updateProduct(wishlistId, productUuid, quantity) {
            const response = await api.patch(`/wishlist/${wishlistId}/item/${productUuid}`, {
                qty: quantity,
            });
            return response.data;
        },
        async deleteProduct(wishlistId, productUuid) {
            const response = await api.delete(`/wishlist/${wishlistId}/item/${productUuid}`);
            return response.data;
        },
        async deletePurchaseItem(wishlistId, productUuid) {
            const response = await api.delete(`/wishlist/${wishlistId}/item/${productUuid}`);
            return response.data;
        },
        async addPublicPurchaseItem(wishlistId, productUuid, quantity) {
            const response = await api.post(`/wishlist/public/${wishlistId}/item/${productUuid}/purchase`, {
                qty: quantity,
            });
            return response.data;
        },
        getShareLink(wishlistId) {
            return `https://${location.host}/wishlist/${wishlistId}`;
        },
        async sendShareEmail(wishlistId, email, message = null) {
            const app = useAppStore();

            const payload = {
                email,
                store: app.getSalesChannelId(),
            };

            if (message && message.trim().length > 0) {
                payload.message = message;
            }

            const response = await api.post(`/wishlist/${wishlistId}/share-email`, payload);
            return response.data;
        },
    },
});
